/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import React from 'react';

import { useTellUsAboutYourExperienceBannerUserFlag, useViewFhirUserFlag } from '../permissions';
import styles from './MessageBar.module.scss';
import { useAppSelector } from '../../../app/hooks';
import { selectIsFhirVisible, selectIsPatientChartPaneVisible, selectPatientContext } from '../Fhir/fhirSlice';
import { selectPatientSummaryState } from './components/PatientSummary/patientSummarySlice';

export function MessageBar() {
  const canViewFhir = useViewFhirUserFlag();
  const show = useTellUsAboutYourExperienceBannerUserFlag();
  if (!canViewFhir || !show) return null;
  return (
    <a
      href="https://forms.office.com/pages/responsepage.aspx?id=hpAxLiaao0aGX2Fb7VdnhmlnUxpeMbpIkagtubRCAAJUNFBZRjBBVFNNVTFVNU5LREtNREFBSTJFOC4u"
      target="_blank"
      rel="noopener noreferrer"
      className={styles.container}
    >
      <div className={styles.messageBar}>~~ Tell us about your experience seeing patient-specific data! ~~</div>
    </a>
  );
}

/*
 * To show disclaimer to only MUSC organization when FHIR content is visible.
 */
export function MUSCFhirMessageBar() {
  const patientContext = useAppSelector(selectPatientContext);
  const user = useAppSelector((state) => state.user.pearlUserInfo);
  const { showContextualization } = useAppSelector(selectPatientSummaryState);
  const isFhirVisible = useAppSelector(selectIsFhirVisible);
  const isPatientChartPaneVisible = useAppSelector(selectIsPatientChartPaneVisible);

  if (user?.orgCode?.toUpperCase() !== 'MUSC' || !user.userFlags?.show_contextualization) return null;

  if (patientContext?.patient && showContextualization && (isFhirVisible || isPatientChartPaneVisible)) {
    return (
      <div className={styles.muscFHIRMessageBar}>
        We are in the early stages of pulling patient data from Epic into MedPearl. During this period of optimization,
        please utilize both MedPearl and Epic for a complete record of patient information.
      </div>
    );
  } else {
    return null;
  }
}
